export var DocsBlockItemVariantLayoutType;
(function (DocsBlockItemVariantLayoutType) {
    /** Layout will stack all its items in this group into column */
    DocsBlockItemVariantLayoutType["column"] = "Column";
    /** Layout will stack all its items in this group into row */
    DocsBlockItemVariantLayoutType["row"] = "Row";
})(DocsBlockItemVariantLayoutType || (DocsBlockItemVariantLayoutType = {}));
